/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
// @ts-nocheck
var deskCartUpsellOfferedAttribute = "_cart_upsell_offered";
var deskCartUpsellPurgePending = null;
var deskCartUpsellEnforceAttempts = 0;

function deskCartUpsellProductId() {
  return (window.deskCartUpsell && window.deskCartUpsell.productId) || 0;
}

function deskVisibleCartCount(cart) {
  var count = Number(cart && cart.item_count) || 0;
  var productId = deskCartUpsellProductId();
  if (!productId || !cart || !cart.items) return count;

  for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].product_id === productId) {
      count -= Number(cart.items[i].quantity) || 0;
    }
  }

  return count < 0 ? 0 : count;
}

function deskCartUpsellIsAloneInCart(cart) {
  var productId = deskCartUpsellProductId();
  if (!productId || !cart || !cart.items || !cart.items.length) return false;

  for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].product_id !== productId) return false;
  }

  return true;
}

function deskCartUpsellSend(options) {
  var request =
    window.cartMutation && !window.cartMutation.isBusy()
      ? window.cartMutation.request(options)
      : null;
  if (request) return request;

  return $.ajax({
    type: "POST",
    url: options.url,
    data: options.data,
    contentType: options.contentType,
    dataType: "json",
  });
}

function deskCartUpsellPurgeIfAlone(cart) {
  if (!deskCartUpsellIsAloneInCart(cart)) return null;
  if (deskCartUpsellPurgePending) return deskCartUpsellPurgePending;

  var request = deskCartUpsellSend({
    url: window.Shopify.routes.root + "cart/clear.js",
  });

  deskCartUpsellPurgePending = request;
  request.always(function () {
    deskCartUpsellPurgePending = null;
  });

  return request;
}

function deskCartUpsellClearOffered() {
  var attributes = {};
  attributes[deskCartUpsellOfferedAttribute] = "";

  return deskCartUpsellSend({
    url: window.Shopify.routes.root + "cart/update.js",
    data: JSON.stringify({ attributes: attributes }),
    contentType: "application/json",
  });
}

function deskCartUpsellResetIfEmpty(cart) {
  if (!cart || cart.item_count !== 0) return null;
  if (!cart.attributes || !cart.attributes[deskCartUpsellOfferedAttribute]) {
    return null;
  }

  return deskCartUpsellClearOffered();
}

function deskCartUpsellResetThenRefresh(cart, refresh) {
  var reset = deskCartUpsellResetIfEmpty(cart);
  if (!reset) {
    if (refresh) refresh();
    return;
  }

  reset.always(function () {
    if (refresh) refresh();
  });
}

function deskCartRefreshAfterUpsellPurge(cart, refresh) {
  var purge = deskCartUpsellPurgeIfAlone(cart);
  if (!purge) {
    deskCartUpsellResetThenRefresh(cart, refresh);
    return;
  }

  purge.always(function (cleared) {
    deskCartUpsellResetThenRefresh(cleared, refresh);
  });
}

function deskCartUpsellAdd(el) {
  if (!window.cartMutation) return null;

  var variantId = parseInt(el.getAttribute("data-variant-id"), 10);
  if (!variantId) return null;

  var updates = {};
  updates[variantId] = 1;

  var attributes = {};
  attributes[deskCartUpsellOfferedAttribute] = "true";

  window.deskSetCartAttributes?.();

  return window.cartMutation.request({
    url: window.Shopify.routes.root + "cart/update.js",
    data: JSON.stringify({ updates: updates, attributes: attributes }),
    contentType: "application/json",
  });
}

function deskCartUpsellLineUpdates(el) {
  var lineKeys = (el.getAttribute("data-line-keys") || "")
    .split(",")
    .filter(Boolean);
  if (!lineKeys.length) return null;

  var updates = {};
  for (var i = 0; i < lineKeys.length; i++) {
    updates[lineKeys[i]] = 0;
  }

  return updates;
}

function deskCartUpsellRemove(el) {
  if (!window.cartMutation) return null;

  var updates = deskCartUpsellLineUpdates(el);
  if (!updates) return null;

  return window.cartMutation.request({
    url: window.Shopify.routes.root + "cart/update.js",
    data: JSON.stringify({ updates: updates }),
    contentType: "application/json",
  });
}

function deskCartUpsellEnforceEligibility(scope, refresh) {
  var root = scope || document;
  var el = root.querySelector("[data-desk-cart-upsell].is-added.is-disabled");
  if (!el) {
    deskCartUpsellEnforceAttempts = 0;
    return false;
  }

  if (deskCartUpsellEnforceAttempts >= 2) return false;

  var updates = deskCartUpsellLineUpdates(el);
  if (!updates) return false;

  deskCartUpsellEnforceAttempts++;
  if (el.ownerDocument === document) el.classList.add("is-loading");

  var done = refresh || window.refreshCartDrawer;
  deskCartUpsellSend({
    url: window.Shopify.routes.root + "cart/update.js",
    data: JSON.stringify({ updates: updates }),
    contentType: "application/json",
  }).done(function (cart) {
    deskCartUpsellResetThenRefresh(cart, done);
  });

  return true;
}

$(document).on("click", "[data-desk-cart-upsell]", function () {
  var el = this;
  if (el.classList.contains("is-loading")) return;
  if (el.classList.contains("is-disabled")) return;

  var isAdded = el.classList.contains("is-added");
  var request = isAdded ? deskCartUpsellRemove(el) : deskCartUpsellAdd(el);
  if (!request) return;

  el.classList.add("is-loading");

  request
    .done(function () {
      window.refreshCartDrawer();
    })
    .fail(function (xhr) {
      el.classList.remove("is-loading");
      console.error("Cart upsell failed:", xhr && xhr.status);
    });
});

document.addEventListener("cart:rendered", function () {
  deskCartUpsellEnforceEligibility();
});

$(document).ready(function () {
  if (window.deskCartUpsell && window.deskCartUpsell.resetOffered) {
    deskCartUpsellClearOffered();
  }
});

window.deskVisibleCartCount = deskVisibleCartCount;
window.deskCartUpsellPurgeIfAlone = deskCartUpsellPurgeIfAlone;
window.deskCartRefreshAfterUpsellPurge = deskCartRefreshAfterUpsellPurge;
window.deskCartUpsellEnforceEligibility = deskCartUpsellEnforceEligibility;
